// MessageSender.jsx
import React, { useState, useCallback, useEffect } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import './MessageSender.css';
import MessageInput from './MessageInput';
import ImageUpload from './ImageUpload';
import ImagePreview from './ImagePreview';
import SubmitButton from './SubmitButton';
import ErrorMessage from './ErrorMessage';
import { useTranslation } from 'react-i18next';

const MessageSender = (props) => {
  const { t } = useTranslation();
  const { showToast, onClose, single, recipient } = props;

  const [message, setMessage] = useState('');
  const [image, setImage] = useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let objectUrl;
    if (image) {
      objectUrl = URL.createObjectURL(image);
      setImagePreviewUrl(objectUrl);
    }
    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [image]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    setError('');

    const formData = new FormData();
    formData.append('fromPhoneNumber', '+19147329805');
    formData.append('message', message);
    if (image) {
      formData.append('image', image);
    }
    if (single && recipient) {
      formData.append('toPhoneNumber', recipient);
    }

    const endpoint = single
      ? 'https://sendsinglesmsalt-34592812516.us-central1.run.app'
      : 'https://sendsmsalt-34592812516.us-central1.run.app';

    try {
      const response = await axios.post(endpoint, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.status === 200) {
        showToast(t('messageSender.sendSuccess'), 'success');
        setMessage('');
        setImage(null);
        setImagePreviewUrl(null);
        setTimeout(() => {
          onClose();
        }, 1000);
      } else {
        showToast(t('messageSender.sendError'), 'error');
      }
    } catch (error) {
      console.error('Error sending message:', error);
      setError(t('messageSender.sendError'));
      showToast(t('messageSender.sendError'), 'error');
    } finally {
      setIsLoading(false);
    }
  };

  const removeImage = () => {
    setImage(null);
    setImagePreviewUrl(null);
  };

  return (
    <div className="message-container">
      <div className="message-recovery-container">
        <h2>{t('messageSender.title')}</h2>
        <form onSubmit={handleSubmit} className="login-form">
          <div className="input-group">
            <MessageInput message={message} setMessage={setMessage} />
            <ImageUpload setImage={setImage} />
            {imagePreviewUrl && (
              <ImagePreview imagePreviewUrl={imagePreviewUrl} removeImage={removeImage} />
            )}
          </div>
          {error && <ErrorMessage error={error} />}
          <SubmitButton isLoading={isLoading} />
        </form>
      </div>
    </div>
  );
};

MessageSender.propTypes = {
  showToast: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  single: PropTypes.bool,
  recipient: PropTypes.string,
};

MessageSender.defaultProps = {
  single: false,
  recipient: '',
};

export default MessageSender;
